import React, { useEffect, useState } from "react";
import { reduxForm, Field } from "redux-form";
import { Grid, Header, Divider, Button } from "semantic-ui-react";
import { renderTextField, renderOptionField } from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
import Swal from "sweetalert2";
const validate = (values) => {
  const errors = {};
  if (!values.categoryType) {
    errors.categoryType = "Required";
  }
  if (!values.categoryName) {
    errors.categoryName = "Required";
  }

  //categoryName

  return errors;
};

const ContactCatogery = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id, catId } = useParams();
  const userDetail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);

  useEffect(() => {
    if (id !== "null") {
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
      getWorkList();
    }
  }, []);
  const catogeryItems = [
    { value: 1, text: "Spend Money" },
    { value: 2, text: "Receive Money" },
    { value: 3, text: "Company List" },
  ];

  const getWorkList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listSSCategory", {
        categoryType: catId,
      })
      .then((res) => {
        console.log("res", res.data);
        const tempData = res.data;
        const filterData = tempData.filter((item) => item.categoryId == id);
        console.log("filterData", filterData);

        initilizeData(filterData);
      })
      .catch((error) => console.log(error));
  };

  const initilizeData = (filterData) => {
    props.initialize({
      categoryId: id,
      categoryName: filterData[0].categoryName,
      categoryType: filterData[0].categoryType,
    });
  };
  const sumbitForm = (values) => {
    console.log(values);
    axios
      .post(BaseUrlInvoice + "accounts/createSSCategory", values)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: "Created",
          });
          navigate(-1);
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === "500") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "This Work Type Already Created",
          });
        }
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Contact Category
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Grid columns="two">
          <Grid.Row>
            {/* <Grid.Column>
              <Field
                name="categoryType"
                label="Category Type"
                options={catogeryItems}
                // onChange={(e) => setforOnChangeValue(e)}
                component={renderOptionField}
              />
            </Grid.Column> */}
            <Grid.Column>
              <Field
                name="categoryName"
                label="Category Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden />
      <>
        {" "}
        <Button
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
              categoryType: 4,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "ContactCatogery",
  validate,
})(ContactCatogery);
